import axios from '@/axios';

export async function getInitialDiagnosis(params) {
    try {
        const { data } = await axios.get("/initial_diagnosis/filter", { params });
        return data.data ? data.data : data;
    } catch (error) {
        return { error };
    }
}

export async function saveInitialDiagnosis(id, data) {
    const method = id ? 'PUT' : 'POST';
    const url = id ? `/initial_diagnosis/${id}` : '/initial_diagnosis/create';
    return await axios({ method, url, data: data });
}
